<template>
    <main>
        <section id="video" class="content-section container px-3">
            
            <div class="d-flex">
                <transition name="fade" mode="out-in">
                    <VideoFrame v-if="videoFrameShow" :currentV="currentV" @back="videoFrameShow = false"/>
                    
                    <div v-else class="video-gallery-container">
                        <div class="mb-5">
                            <h2 class="content-section-title">COMPANY VIDEOS</h2>
                            <VideoList @swVideo="swVideo" :videos="getVideoList('ad')" />
                        </div>
                        <div class="mb-5">
                            <h2 class="content-section-title">INSTALLATION VIDEOS【Multi-funtion adapter】</h2>
                            <VideoList @swVideo="swVideo" :videos="getVideoList('install', 'vg')" />
                        </div>
                        <div class="mb-5">
                            <h2 class="content-section-title">INSTALLATION VIDEOS</h2>
                            <VideoList @swVideo="swVideo" :videos="getVideoList('install', 'bg')" />
                        </div>
                    </div>
                    
                </transition>
            </div>

        </section>
    </main>
</template>

<script>
import VideoFrame from './VideoFrame'
import VideoList from './VideoList'

export default {
    components: {
        VideoList,
        VideoFrame,
    },
    data() {
        return {
            videoFrameShow: false,
            currentV: '',
            videoGallery: [
                { type:'install', brand: 'vg', title: 'Top Lock Arm "2" (4 in 1 Multi-function adapter)', ytId: 's8DWeZtjZoc'},
                { type:'install', brand: 'vg', title: 'Top Lock Arm "4" (4 in 1 Multi-function adapter)', ytId: 'IWCwaRlP-iM'},
                { type:'install', brand: 'vg', title: 'Pinch Tab Arm (4 in 1 Multi-function adapter)', ytId: 'Nvv1oUKSUj8'},
                { type:'install', brand: 'vg', title: 'Side Pin Arm (4 in 1 Multi-function adapter)', ytId: 't-OHlFFTtEE'},
                { type:'install', brand: 'vg', title: 'Pinch Tab Arm (2 in 1 Multi-function adapter)', ytId: '2ak5fRML4HU'},
                { type:'install', brand: 'vg', title: 'Bayonet Lock Arm (2 in 1 Multi-function adapter)', ytId: '8pC_rPDaX3E'},
                { type:'install', brand: 'bg', title: 'Hook Type (9*3/B1)', ytId: 'wBR7yqMsvS0'},
                { type:'install', brand: 'bg', title: 'Top Lock Arm (TL-2 adapter)', ytId: 'gbmRE697kRs'},
                { type:'install', brand: 'bg', title: 'Top Lock Arm (TL-4 adapter)', ytId: 'm1md_gajqh8'},
                { type:'install', brand: 'bg', title: 'Pinch Tab Arm (PT-3 adapter)', ytId: 'omOJcmBAkiU'},
                { type:'install', brand: 'bg', title: 'Side Pin Arm (PH-2 adapter)', ytId: 'ZPDlEZKOy70'},
                { type:'install', brand: 'bg', title: 'Top Lock Arm (M5-TLC adapter)', ytId: 'ZcI-ZpfoRGI'},
                { type:'install', brand: 'bg', title: 'Pinch Tab Arm (PT-6 adapter)', ytId: 'dndWWB6wjbw'},
                { type:'install', brand: 'bg', title: 'Bayonet Lock Arm (BL-2 adapter)', ytId: 'rmghv1p_Sp4'},
                { type:'install', brand: 'bg', title: 'Central Lock Arm (CL adapter)', ytId: 'n8bCJ-zdNh8'},
                { type:'install', brand: 'bg', title: 'Mercedes Lock Arm (ML adapter)', ytId: 'KeIGn6pvz-w'},
                { type:'install', brand: 'bg', title: 'Pinch Lock Arm (PL adapter)', ytId: 'LoFaLbj703k'},
                { type:'ad', brand: 'st', title: '【 佰視佳雨刷，把安全帶回家 】Scan Top Group', ytId: 'GK0zu8Cuuj8'},
                { type:'ad', brand: 'st', title: '【 Windshield Wiper blade 】Scan Top Group - UPC Factory', ytId: '1U7_s5XpY6s'},
                { type:'ad', brand: 'st', title: '【雨刷製造，匠人精神】金頂集團 - 鎮威雨刷製造廠', ytId: 'hLHfkokai10'},
            ]
        }
    },
    methods: {
        swVideo(currentV) {
            this.videoFrameShow = true
            this.currentV = currentV
            location.href = '#video';
        },
        getVideoList(type, brand='') {
            return this.videoGallery.filter(v => {
                let t = v.type == type ? true : false
                let b = true
                if(brand !== '') {
                    b = v.brand == brand ? true : false
                }
                
                return t && b
            })
        }
    },
}
</script>

<style >
    #video{
        overflow: hidden;
    }
    .video-gallery-container{
        flex: 1 0 100%;
        height: auto;
    }
</style>